import { useCallback, useState } from 'react';
import { useCartAddItem } from '@backpackjs/storefront';
import { Image } from '../../../snippets';
import { useGlobalContext } from '../../../contexts';

export function OrdersItemLine({ lineItem }) {
  const [isAdding, setIsAdding] = useState(false);

  const { cartAddItem } = useCartAddItem();
  const {
    actions: { openCart },
  } = useGlobalContext();

  const handleAddToCart = useCallback(async () => {
    setIsAdding(true);

    const variantId = lineItem.variant.id;

    await cartAddItem({
      merchandiseId: variantId,
      quantity: 1,
    });

    setIsAdding(false);

    openCart();
  }, []);

  return (
    <div className="mt-3 flex justify-between">
      <div className="item flex w-1/2 items-center">
        <Image
          src={lineItem.variant.image.src}
          alt={lineItem.variant.image.altText}
          width={64}
          height={64}
          className="mr-2"
        />
        <span className="text-xs">{lineItem.title}</span>
      </div>
      <div className="flex items-center">
        <button
          type="button"
          onClick={handleAddToCart}
          className="rounded-full bg-textLink px-4 py-2 text-xs text-white hover:bg-primary focus:bg-primary"
        >
          {isAdding ? 'Adding...' : 'Buy Again'}
        </button>
      </div>
    </div>
  );
}

OrdersItemLine.displayName = 'OrdersItemLine';
